<h2 class="modal-title">Création - {{ appSettingsLabel }}</h2>

<div class="import-modal">
  @if (appSettingsId === 'APPSETTINGS|ACTIVE-FEATURES|1.0.0') {
    <ms-form-active-features
      [initialForm]="initialActiveFeaturesForm"
      (formChange)="onFormChange($event)">
    </ms-form-active-features>
  }

  @if (appSettingsId === 'APPSETTINGS|CONNECTION-MODE|1.0.0') {
    <ms-form-connection-mode
      (formChange)="onFormChange($event)">
    </ms-form-connection-mode>
  }

  @if (appSettingsId === 'APPSETTINGS|1733-CONFIG|1.0.0') {
    <ms-form-config-1733
      (formChange)="onFormChange($event)">
    </ms-form-config-1733>
  }

  @if (appSettingsId === 'APPSETTINGS|BEOOGO|PRD|1.0.1') {
    <ms-form-beoogo
      (formChange)="onFormChange($event)"
      (validChange)="onValidChange($event)">
    </ms-form-beoogo>
  }

  @if (appSettingsId === 'APPSETTINGS|EFORM|PRD|1.0.0') {
    <ms-form-eform
      (formChange)="onFormChange($event)"
      (validChange)="onValidChange($event)">
    </ms-form-eform>
  }
</div>

<div class="footer-actions">
  <button class="btn cancel" (click)="closeDialog()">Annuler</button>
  <button class="btn confirm" [disabled]="!isFormValid" (click)="save()">Créer</button>
</div>
